import api from '@/configurations/service';
import * as types from './mutation-types';

export const setConfiguration = async (context) => {
  const { data } = await api().post('consumers.find-nfse-configuration');

  context.commit(types.SET_CONFIGURATION, data);
};

export const updateConfiguration = async (_, payload) => {
  await api().post('consumers.update-nfse-configuration', payload);
};
